import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const myUpgradeRoute: RouteConfig<'with-page'> = {
    name: 'Upgrade',
    path: '/myaccount/upgrade',
    context: 'member',
    page: lazy(() => import('.')),
    flags: ['member-route'],
}